import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, catchError, mergeMap, of, switchMap } from 'rxjs';
import { GroupService } from './group.service';
import { SocketService } from './socket.service';

@Injectable({
  providedIn: 'root'
})
export class LogbookService {
  private apiUrl = 'api';
  private logbookSubject = new BehaviorSubject<any[]>([]);

  logbook$ = this.logbookSubject.asObservable();

  groupId: any;
  currentPage = 1;
  pageSize = 500;
  isLoading = false;

  constructor(private http: HttpClient, private groupService: GroupService, private socketService: SocketService) {

    this.setupRealTimeUpdates();

    this.groupService.selectedGroup$.pipe(
      switchMap(selectedGroup => {
        if (selectedGroup) {
          this.groupId = selectedGroup.id;
          this.currentPage = 1;
          this.logbookSubject.next([]);
          return this.loadLogook();
        }
        return EMPTY;
      })
    ).subscribe();
  }

  private setupRealTimeUpdates(): void {
    // Listen for a new item being added
    this.socketService.listen('noteAdded', 'logbook-service').subscribe((newData) => {
      //const formatted = formatDates(newData);
      const current = this.logbookSubject.getValue();
      //this.tasksSubject.next([...current, formatted]); // Add the new item
      if (newData.isProcedure) {
        this.logbookSubject.next([...current, newData]); // Add the new item
      }
    });

    // Listen for updates
    this.socketService.listen('noteUpdated', 'logbook-service').subscribe((updated) => {
      //const formatted = formatDates(updated);

      // Update in the main list
      const current = this.logbookSubject.getValue();
      //const index = current.findIndex(p => p.id === formatted.id);
      const index = current.findIndex(p => p.id === updated.id);
      if (index !== -1) {
        //current[index] = formatted;
        current[index] = updated;
        this.logbookSubject.next([...current]); // Replace the item in the array
      } else if (updated.isProcedure) {
        this.logbookSubject.next([...current, updated]); // Add the new item
      }
    });

    // Listen for an item being deleted
    this.socketService.listen('noteDeleted', 'logbook-service').subscribe((deleted) => {
      //const formatted = formatDates(deleted);

      const current = this.logbookSubject.getValue();
      //const updated = current.filter(p => p.id !== formatted.id);
      const updated = current.filter(p => p.id !== deleted.id);
      this.logbookSubject.next(updated); // Remove the deleted item
    });

    this.socketService.listen('patientUpdated', 'logbook-service').subscribe((updatedPatient) => {
      // Get the current value of logbookSubject
      const current = this.logbookSubject.getValue();

      // Map through the current logbook list to update the specific patient's details
      const updatedLogbook = current.map(item => {
        if (item.patientId === updatedPatient.id) {
          // Update the diagnosis for the specific patient
          return {
            ...item,
            Patient: {
              ...item.Patient,
              name: updatedPatient.name,
              surname: updatedPatient.surname,
              diagnosis: updatedPatient.diagnosis,
              patientNumber: updatedPatient.patientNumber,
              requiresValidation: updatedPatient.requiresValidation,
              requiresICDValidation: updatedPatient.requiresICDValidation,
              wasSelfBoarded: updatedPatient.wasSelfBoarded,
              status: updatedPatient.status,
            }
          };
        }
        return item;
      });

      // Update the logbookSubject with the new list
      this.logbookSubject.next(updatedLogbook);
    });


  }

  loadLogook(): Observable<any[]> {
    if (this.isLoading) {
      return EMPTY;
    }
    this.isLoading = true;
    return this.getLogbookByGroup(this.groupId, this.currentPage, this.pageSize).pipe(
      mergeMap((res: any) => {
        const items = res.data;
        const current = this.logbookSubject.getValue();
        const updated = [...current, ...items];
        this.logbookSubject.next(updated);
        if (items.length === this.pageSize) {
          this.currentPage++;
          this.isLoading = false;
          return this.loadLogook();
        } else {
          this.isLoading = false;
          return of(updated);
        }
      }),
      catchError(error => {
        this.isLoading = false;
        return of([]);
      })
    );
  }

  getLogbookByGroup(groupId: string, page: number, pageSize: number): Observable<any[]> {
    const token = localStorage.getItem('token');
    return this.http.get<any[]>(`${this.apiUrl}/logbook/group/${groupId}?page=${page}&pageSize=${pageSize}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }


}
